import ReactGA from "react-ga";

const sendEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

export { sendEvent };
